<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { getInitialBaselineOffset } from './initialMetrics';

const props = defineProps({
  initial: { type: String, required: true },
  sizeClass: { type: String, default: '' },
});
const isArabic = computed(() => /\p{Script=Arabic}/u.test(props.initial));
const glyph = ref(null);
const baselineOffset = ref(null);

const alignGlyph = async () => {
  if (!isArabic.value) return;
  await document.fonts.ready;
  if (!glyph.value) return;
  baselineOffset.value = getInitialBaselineOffset(
    props.initial,
    getComputedStyle(glyph.value).font
  );
};

onMounted(alignGlyph);
watch(() => [props.initial, props.sizeClass], alignGlyph, { flush: 'post' });
</script>

<template>
  <svg
    v-if="isArabic"
    class="size-full shrink-0 overflow-visible fill-current"
    :class="sizeClass"
    focusable="false"
  >
    <!-- Center the visible ink, including Arabic descenders and dots. -->
    <text
      ref="glyph"
      x="50%"
      y="50%"
      text-anchor="middle"
      :dominant-baseline="baselineOffset === null ? 'central' : 'alphabetic'"
      :dy="baselineOffset"
    >
      {{ initial }}
    </text>
  </svg>
  <span v-else :class="sizeClass">{{ initial }}</span>
</template>
